export const lang = {
    message: {
        loginTitle: 'Temperature Control Management System',
        loginUser: 'Your username',
        loginPassword: 'Your password',
        loginBtn: 'Sign In',
        homeTitle: 'Temperature Control Management System',
        logout: 'Exit',
        exit: 'Exit successfully',
        loginSuccess: 'Login Successful!',
        loginFailed: 'Account or password is wrong, please log in again!',

        menuUser: 'User Management',
        menuDev: 'Device Management',
        userTitle: 'User Management',
        userNumber: 'Number',
        userName: 'UserName',
        userAccount: 'Account',
        userDevicesNum: 'Devices',
        userEmail: 'Email',
        userOpeateModify: 'Modify',
        userOpeateDelete: 'Delete',
        userViewBindDev: 'Binding Device',
        userDialogModifyTitle: 'Modify',
        userDialogModifyUserName: 'UserName',
        userDialogModifyPassWord: 'PassWord',
        userNamePlaceHolder: '',
        userEmailPlaceHolder: '',
        userAccountPlaceHolder: '',

        opeate: 'Operate',
        opeateView: 'View',

        devTitle: 'Device Management',
        devName: 'Device Name',
        devMacAddr: 'Mac Address',
        devDetails: 'Details',
        devID: 'DeviceID',
        devMAC: 'MAC address',
        devNames: 'DeviceName',
        devIdPlaceHolder: '',
        devMACPlaceHolder: '',
        devNamePlaceHolder: '',

        btnYes: 'OK',
        btnNo: 'Cancel',

        boxTitle: 'Waring',
        boxTips: 'This will permanently delete the file. Continue?',
        boxDelCancel: 'Delete canceled',
        boxDelSuccess: 'Delete completed',
        boxModifySuccess: 'Modify completed',
        boxModifyFailed: 'Modify failed',
        boxModifyFailedMsg: 'Please fill in username or password',
        boxModifypswErr: 'Password can only consist of letters and numbers',
        boxModifypswLength: 'Password length should be 6 to 16',
        boxModifynameLength: 'Username length should be 1 to 16',

        pagePre: 'Pre',
        pageNext: 'Next',

        tableNoData: 'No data',

        formUserTitle: {
            kaiguan: "ON/OFF",
            shouzi: "MODEL",
            jianpan: "LOCK",
            famen1: "Valve 1 status",
            fangdong: "Frost protection",
            override: "override",
            wendushow: "Temperature format",
            week: 'Schedule'
        },
        wendu: 'Room temperature',
        setwendu: "Set at",
        time: "Time",
        userState: {
            kaiguan: {
                0: 'OFF',
                1: 'ON'
            },
            shouzi: {
                0: 'Auto mode',
                1: "Manual mode"
            },
            jianpan: {
                0: 'Unlocked',
                1: 'Locked'
            },
            famen1: {
                0: 'OFF',
                1: 'ON'
            },
            fangdong: {
                0: 'OFF',
                1: 'ON'
            },
            override: {
                0: 'No',
                1: 'Yes'
            },
            wendushow: {
                0: '℃',
                1: '℉'
            },
            week: {
                0: 'Sunday',
                1: 'Monday',
                2: 'Tuesday',
                3: 'Wednesday',
                4: 'Thursday',
                5: 'Friday',
                6: 'Saturday'
            }
        },
        formDevTitle: {
            cewen: ' Sensor selection',
            cewenshow: ' Temperature readout(AF mode only)',
            timeshow: 'Clock format',
            biancheng: 'Program mode',
            waiwenchuangan: 'Sensor type selection',

            kaiguan: "ON/OFF",
            shouzi: "MODEL",
            jianpan: "LOCK",
            famen1: "Valve 1 status",
            fangdong: "Frost protection",
            overide: "override",
            wendushow: "Temperature format",
            week: 'Schedule'
        },

        huicha: 'Switching differential',
        neijiao: 'Air temperature calibration',
        waijiao: 'Floor temperature calibration',
        waiwenshang: 'Max floor temperature setting',
        wensia: 'Minimum temperature limit',
        wenshang: 'Maximum temperature limit',
        beiguang: 'Backlit time',
        devState: {
            cewen: {
                0: 'A',
                1: 'AF',
                2: 'F'
            },
            cewenshow: {
                0: 'A',
                1: 'AF',
                2: 'F'
            },
            timeshow: {
                0: '24h',
                1: '12h',
            },
            biancheng: {
                0: '5+2',
                1: '7day',
            },
            waiwenchuangan: {
                0: '3K',
                1: '15k',
                2: '10k',
                3: '100k'
            },
            kaiguan: {
                0: 'OFF',
                1: 'ON'
            },
            shouzi: {
                0: 'Auto mode',
                1: "Manual mode"
            },
            jianpan: {
                0: 'Unlocked',
                1: 'Locked'
            },
            famen1: {
                0: 'OFF',
                1: 'ON'
            },
            fangdong: {
                0: 'OFF',
                1: 'ON'
            },
            overide: {
                0: 'No',
                1: 'Yes'
            },
            wendushow: {
                0: '℃',
                1: '℉'
            },
            week: {
                0: 'Sunday',
                1: 'Monday',
                2: 'Tuesday',
                3: 'Wednesday',
                4: 'Thursday',
                5: 'Friday',
                6: 'Saturday'
            }
        }
    }
}